export default __webpack_public_path__ + "static/media/noun_call_2091475.ce3e56c6.svg";